import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Clock } from 'lucide-react';
import DatePickerPopover from '../DatePickerPopover';
import MiniScheduleCalendar from '../MiniScheduleCalendar';

/**
 * Schedule picker card for a ticket detail page.
 * Extracted from TicketDetailPage for readability.
 */
const SchedulePickerCard = ({
  ticket,
  ticketId,
  scheduleForm,
  setScheduleForm,
  scheduleLoad,
  onSave,
  saving,
  canEdit,
}) => (
  <Card className="border-border">
    <CardHeader className="border-b border-border">
      <CardTitle className="text-lg tracking-tight font-medium flex items-center gap-2">
        <Clock className="w-5 h-5" />
        Jadwal Pengerjaan
      </CardTitle>
    </CardHeader>
    <CardContent className="pt-4 space-y-3">
      <MiniScheduleCalendar
        value={scheduleForm.scheduled_start}
        onSelect={(d) => setScheduleForm({ ...scheduleForm, scheduled_start: d })}
        excludeTicketId={ticketId}
        category={ticket?.category}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div className="min-w-0">
          <Label className="text-xs">Mulai</Label>
          <DatePickerPopover
            value={scheduleForm.scheduled_start}
            onChange={(v) => setScheduleForm({ ...scheduleForm, scheduled_start: v })}
            disabled={!canEdit}
            testId="schedule-start-input"
          />
        </div>
        <div className="min-w-0">
          <Label className="text-xs">Selesai</Label>
          <DatePickerPopover
            value={scheduleForm.scheduled_end}
            onChange={(v) => setScheduleForm({ ...scheduleForm, scheduled_end: v })}
            disabled={!canEdit}
            testId="schedule-end-input"
          />
        </div>
      </div>
      {scheduleLoad.count > 0 && (
        <div
          className={`p-2.5 rounded-md text-xs border ${
            scheduleLoad.count >= 4
              ? 'bg-red-50 border-red-300 text-red-800'
              : scheduleLoad.count >= 2
                ? 'bg-amber-50 border-amber-300 text-amber-900'
                : 'bg-blue-50 border-blue-200 text-blue-900'
          }`}
          data-testid="schedule-load-warning"
        >
          <p className="font-medium mb-1">
            {scheduleLoad.count >= 4
              ? `⚠️ Tanggal ini sudah PADAT — ada ${scheduleLoad.count} jadwal maintenance/IT`
              : scheduleLoad.count >= 2
                ? `⚠️ Tanggal ini sudah ada ${scheduleLoad.count} jadwal maintenance/IT`
                : `ℹ️ Tanggal ini sudah ada ${scheduleLoad.count} jadwal maintenance/IT`}
          </p>
          <ul className="space-y-0.5 mt-1">
            {scheduleLoad.tickets.slice(0, 4).map((t) => (
              <li key={t.id} className="truncate">• {t.ticket_number} — {t.title}</li>
            ))}
          </ul>
        </div>
      )}
      <div>
        <Label className="text-xs">Catatan Jadwal</Label>
        <Textarea
          placeholder="Contoh: teknisi Budi, akses lewat pintu belakang"
          value={scheduleForm.schedule_note}
          onChange={(e) => setScheduleForm({ ...scheduleForm, schedule_note: e.target.value })}
          rows={2}
          data-testid="schedule-note-input"
          disabled={!canEdit}
        />
      </div>
      {canEdit && (
        <Button
          onClick={onSave}
          disabled={saving}
          size="sm"
          className="w-full bg-primary hover:bg-primary/90"
          data-testid="save-schedule-button"
        >
          {saving ? 'Menyimpan...' : 'Simpan Jadwal'}
        </Button>
      )}
    </CardContent>
  </Card>
);

export default SchedulePickerCard;
